import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { DiaryEntries } from './components/DiaryEntries';
import { ProductExplanation } from './components/ProductExplanation';
import { DidYouKnow } from './components/DidYouKnow';
import { ExpertQuote } from './components/ExpertQuote';
import { Testimonials } from './components/Testimonials';
import { BeforeAfter } from './components/BeforeAfter';
import { TrustBar } from './components/TrustBar';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];
    w[l].push({'gtm.start':new Date().getTime(),
    event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='
    +i+dl;f.parentNode.insertBefore(j,f);})(window,document,
    'script','dataLayer','GTM-KZBZMFT');`;
    document.head.appendChild(script);
    const gclid = new URLSearchParams(window.location.search).get('gclid');
    if (gclid) {
      document.querySelectorAll('a[href*="hunderunde.shop"]').forEach(link => {
        const el = link as HTMLAnchorElement;
        const sep = el.href.includes('?') ? '&' : '?';
        el.href = el.href + sep + 'gclid=' + gclid;
      });
    }
  }, []);
  return <div className="min-h-screen bg-cream font-serif text-gray-800 selection:bg-forest/20" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <DiaryEntries data-id="element-4" />
        <ProductExplanation data-id="element-5" />
        <DidYouKnow data-id="element-6" />
        <ExpertQuote data-id="element-7" />
        <Testimonials data-id="element-8" />
        <BeforeAfter data-id="element-9" />
        <TrustBar data-id="element-10" />
        <CTASection data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
    </div>;
}